import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';

import { LlmConfigPage } from './imports';

export const llmConfigRoutes = [
  {
    path: 'llms',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.INTEGRATIONS}
            submodule={OrionSubmodule.INTEGRATIONS.LLM_CONFIG}
            access={OrionAccess.VIEW}
          >
            <LlmConfigPage />
          </PermissionGuard>
        ),
        index: true,
      },
    ],
  },
];
